import React, {useEffect,useState} from 'react';
import {useHistory,  useLocation} from 'react-router-dom';
import {useSelector, useDispatch, } from 'react-redux';
import FormChild from './FormChild'
import IconSelector from '@ibibo/icon-selector';
import {setter, hasItem, getter} from '../../../../../../../common/client-side-storage/src/client-side-storage.web';
import useRedirect from '../../../../pages/Onboarding/hooks/useRedirection'
import {sendEvarData} from '@ibibo/analytics';

import * as C from '../Common.styles';
import {setAgentData} from '../../../../store/actions/thunk';
import {HOME_PAGE_URL, REGISTERED_PAGE_URL, VERIFICATION_PAGE_URL, LOGIN_PAGE_URL, VERIFY_PAGE_URL} from '../../../../constants';
import {tokenSelector, directLandingSelector, statusSelector,errorSelector,sessionExpireSelector} from '../../../../store/selectors';


const FormContainerUI = ({children, step}) => {
  const history = useHistory();
  const location = useLocation()
  const dispatch = useDispatch();

  const directLanding = useSelector(directLandingSelector);
  const token = useSelector(tokenSelector);
  const status = useSelector(statusSelector);
  const sessionExpiry = useSelector(sessionExpireSelector);
  const error = useSelector(errorSelector);

  const [showTimer, setShowTimer] = useState((sessionExpiry ? sessionExpiry : 0)!=0);

  const [data, setData] = useState('')
  const [popUp, showModal,setShowModal] = useRedirect()

  const successCallback = (data) => {
    setData(data)
  }

//   useEffect(() => {
//     console.log(showModal, 'in FORM')
//     if (error ) {return};
//     if (!timeLeft && showModal) {return}
//     if (!timeLeft && !showModal) {setShowModal(true)}else{tick()}
//     if (timeLeft && !showModal) {tick()}
//     },)

//   const tick = () => {
//     setTimeout(function(){
//       setTimeLeft(timeLeft-1);
//     }, 1000);
//   }


//   const getTime = (time) => {
//     let min = Math.floor(time / 60);
//     let seconds = time - (min * 60);
//     let secondsDisplay = seconds ? (seconds < 10 ? `0${seconds}s` : `${seconds}s`) : '00s '
//     return `${min}m:${secondsDisplay}`
//   }

  const errorCallback = () => {
    history.push(HOME_PAGE_URL);
  }

  useEffect(() => {
    if (token) {
      dispatch(setAgentData(token, successCallback, errorCallback));
    } else if (!token && step !== 1) {
      history.push(HOME_PAGE_URL);

      /*
      Related to the Business tagging use case
      Covers the case where the agent lands, closes the window, opens it manually without the business reference.
      Whenever user lands on the page and once component mounts, we store the ref, later used when submitting the form
      */
    }else if (!token && step === 1 ) {
        let searchString = new URLSearchParams(location.search)
        if (searchString.has('ref') && !hasItem("ref")) {
          setter('ref', searchString.get("ref"))
        }
        if (searchString.has('cmp')) {
            setter('cmp', hasItem('cmp') ? `${getter('cmp')};${searchString.get('cmp')}` : searchString.get('cmp'))
          }
    }

  }, []);

  useEffect(() => {
    switch (status) {
      case 'active':
        // goto login page
        history.push(LOGIN_PAGE_URL);
        break;
      // case 'approved':
      //   // goto registered page
      //   history.push(`${REGISTERED_PAGE_URL}?t=${token}`);
      //   break;
      case 'manual':
        // goto verification page
        history.push(`${VERIFICATION_PAGE_URL}?t=${token}`);
        break;
      default:
        break;
    }
  }, [status])

  const goBack = () => {
    let evarStr = ""
    if(step == 2) {
      evarStr = "myPartner|signup|OTPVerification|previousStep"
    } else if (step == 3) {
      evarStr = "myPartner|signup|businessVerification|previousStep"
    }
    sendEvarData({
      prop54: evarStr
    }, true)
    history.goBack();
  }

  const totalSteps = 3;

  let borderDiv = null;
  switch (step){
    case 1:
      borderDiv = <C.SignUpStepIndicator />;
      break;
    case 2:
      borderDiv = <C.SignUpStepIndicatorTwo />;
      break;
    case 3:
      borderDiv = <C.SignUpStepIndicatorThree />;
      break;
    default:
      borderDiv = null;
      break;
  }

  const showStep = (step === 1 || step === 2 || step === 3);

  return (
    <C.SignUpMainWrapper>
      <C.SignUpWhiteOuterWrapper>
        <C.SignUpWhiteInner>
          {(showStep && (
            <C.SignUpStepWrapper>
              <C.SignUpStepIconWrap onClick={goBack} disabled={(step === 1 ? true : false)}>
                <IconSelector iconKey='back' props={{disabled: (step === 1 ? true : false) }} />
              </C.SignUpStepIconWrap>
              <C.SignUpStepTextWrap>
                <C.SignUpStepBlueText>STEP {step}</C.SignUpStepBlueText>
                <C.SignUpStepNormalText> OF {totalSteps}</C.SignUpStepNormalText>
              </C.SignUpStepTextWrap>
              {step==3  ?
              <>
              {showTimer && <FormChild error={error} modal={showModal} showModal = {setShowModal}/>}
              {popUp}
              </>
              : null}
              {borderDiv}
            </C.SignUpStepWrapper>
          )) ||
            null}
          {children}
          {/* <VerificationRequired /> */}
        </C.SignUpWhiteInner>
      </C.SignUpWhiteOuterWrapper>
    </C.SignUpMainWrapper>

  );
};

export default FormContainerUI;
